var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"wifiMap"}},[_c('groupDiv')],1)}
var staticRenderFns = []

export { render, staticRenderFns }